const images = {
  upBtn: '/assets/components/CSetting/ic-dropdown-01.png',
  downBtn: '/assets/components/CSetting/ic-dropdown-02.png',
};

export default images;
